import { store, getContext, getConfig } from '@wordpress/interactivity';

function validarEmail(valor) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(valor);
}

document.addEventListener('input', (e) => {
    const el = e.target;
    if (el.tagName !== 'TEXTAREA' || !(el.maxLength > 0)) return;
    const counter = el.nextElementSibling;
    if (!counter || !counter.classList.contains('pp-form__contador')) return;
    const remaining = el.maxLength - el.value.length;
    counter.textContent = remaining + ' / ' + el.maxLength;
    counter.dataset.limit = remaining <= 20 ? 'true' : 'false';
});

store('premis/formularioNominacion', {
    state: {
        get criterioBloqueOculto() {
            const ctx = getContext();
            return ctx.catGrupoId !== ctx.categoriaId;
        },
        get ocultarAdelante() {
            return getContext().paso >= 3;
        },
        get mostrarErrorNominadorNombre() { return getContext().errorNominadorNombre !== ''; },
        get mostrarErrorNominadorEmail()  { return getContext().errorNominadorEmail !== ''; },
        get mostrarErrorNombreCandidato()   { return getContext().errorNombreCandidato !== ''; },
        get mostrarErrorEmailCandidato()    { return getContext().errorEmailCandidato !== ''; },

        get mostrarErrorComarcaId()         { return getContext().errorComarcaId !== ''; },
        get mostrarErrorMunicipio()         { return getContext().errorMunicipio !== ''; },
        get mostrarErrorCategoriaId()       { return getContext().errorCategoriaId !== ''; },
        get mostrarErrorTitular()           { return getContext().errorTitular !== ''; },
        get mostrarErrorJustificacion()     { return getContext().errorJustificacion !== ''; },
        get mostrarErrorRgpd()              { return getContext().errorRgpd !== ''; },
        get esPaso1() { return getContext().paso === 1; },
        get esPaso2() { return getContext().paso === 2; },
        get esPaso3() { return getContext().paso === 3; },
        get esPaso4() { return getContext().paso === 4; },
        get esUltimoPaso() { return getContext().paso === 3; },
        get ocultarNavegacion() {
            const ctx = getContext();
            return ctx.paso === 4 || ctx.candidatoJaExisteix;
        },
        get mostrarFotoOk() {
            const ctx = getContext();
            return !ctx.fotoSubiendo && ctx.fotoAttachmentId > 0;
        },
        get etiquetaPaso() {
            return `Pas ${getContext().paso} de 3`;
        },
    },
    actions: {
        actualizarCampo(event) {
            const ctx = getContext();
            const campo = event.target.dataset.campo;
            if (!campo) return;
            const valor = event.target.value;
            ctx[campo] = (campo === 'categoriaId' || campo === 'comarcaId') ? Number(valor) : valor;
            const errorKey = 'error' + campo.charAt(0).toUpperCase() + campo.slice(1);
            if (errorKey in ctx) ctx[errorKey] = '';
        },
        adelante() {
            const ctx = getContext();
            if (ctx.paso === 1) {
                let hayError = false;
                if (!ctx.nominadorNombre.trim()) {
                    ctx.errorNominadorNombre = 'El teu nom és obligatori';
                    hayError = true;
                }
                if (!ctx.nominadorEmail.trim()) {
                    ctx.errorNominadorEmail = "El teu correu electrònic és obligatori";
                    hayError = true;
                } else if (!validarEmail(ctx.nominadorEmail)) {
                    ctx.errorNominadorEmail = "El format del correu electrònic no és vàlid";
                    hayError = true;
                }
                if (hayError) return;
            }
            if (ctx.paso === 2) {
                let hayError = false;
                if (!ctx.nombreCandidato.trim()) {
                    ctx.errorNombreCandidato = 'El nom / raó social és obligatori';
                    hayError = true;
                }
                if (!ctx.emailCandidato.trim()) {
                    ctx.errorEmailCandidato = "El correu electrònic és obligatori";
                    hayError = true;
                } else if (!validarEmail(ctx.emailCandidato)) {
                    ctx.errorEmailCandidato = "El format del correu electrònic no és vàlid";
                    hayError = true;
                }
                if (!ctx.comarcaId) {
                    ctx.errorComarcaId = 'Has de seleccionar una comarca';
                    hayError = true;
                }
                if (!ctx.municipio.trim()) {
                    ctx.errorMunicipio = 'El municipi és obligatori';
                    hayError = true;
                }
                if (!ctx.categoriaId) {
                    ctx.errorCategoriaId = 'Has de seleccionar una categoria';
                    hayError = true;
                }
                if (hayError) return;
            }
            if (ctx.paso < 3) {
                ctx.paso += 1;
                document.getElementById('pp-formulario-nominacion')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        atras() {
            const ctx = getContext();
            if (ctx.paso > 1) {
                ctx.paso -= 1;
                document.getElementById('pp-formulario-nominacion')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        async enviar(event) {
            event.preventDefault();
            const ctx = getContext();

            let hayError = false;
            if (!ctx.titular.trim()) {
                ctx.errorTitular = 'El titular és obligatori';
                hayError = true;
            } else if (ctx.titular.length > 60) {
                ctx.errorTitular = 'El titular no pot superar els 60 caràcters';
                hayError = true;
            }
            if (!ctx.justificacion.trim()) {
                ctx.errorJustificacion = 'La descripció és obligatòria';
                hayError = true;
            } else if (ctx.justificacion.trim().length < 30) {
                ctx.errorJustificacion = 'La descripció ha de tenir com a mínim 30 caràcters';
                hayError = true;
            }
            if (!ctx.rgpdAcceptat) {
                ctx.errorRgpd = "Has d'acceptar la política de privacitat per continuar";
                hayError = true;
            }
            if (hayError) return;

            ctx.enviando = true;
            ctx.errores = [];
            try {
                const config = getConfig();
                const formData = new FormData();
                formData.append('action', 'pp_registrar_nominacion');
                formData.append('nonce', config.nonce ?? '');
                const camposUi = new Set(['paso', 'enviando', 'exito', 'fotoSubiendo', 'fotoError', 'candidatoJaExisteix', 'candidatoNomExistent']);
                Object.keys(ctx).forEach(k => {
                    if (!camposUi.has(k) && typeof ctx[k] !== 'object') formData.append(k, String(ctx[k]));
                });
                document.querySelectorAll('[data-criterio-id]').forEach(el => {
                    if (el.value.trim()) {
                        formData.append(`criterio_${el.dataset.criterioId}`, el.value.trim());
                    }
                });
                const r = await fetch(config.ajaxUrl ?? '/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body: formData,
                });
                const data = await r.json();
                if (data.success) {
                    ctx.exito = true;
                    ctx.paso = 4;
                } else if (data.data?.codi === 'candidato_existent') {
                    ctx.candidatoJaExisteix = true;
                    ctx.candidatoNomExistent = data.data.nom ?? '';
                } else {
                    ctx.errores = data.data?.errores ?? ['Error desconegut'];
                }
            } catch (e) {
                ctx.errores = ['Error de xarxa, torna-ho a intentar'];
            } finally {
                ctx.enviando = false;
            }
        },
        confirmarEnvio() {
            const ctx = getContext();
            ctx.candidatoJaExisteix = false;
            ctx.confirmar = true;
            document.querySelector('#pp-formulario-nominacion form').requestSubmit();
        },
        cancelarEnvio() {
            const ctx = getContext();
            ctx.candidatoJaExisteix = false;
            ctx.confirmar = false;
        },
        actualizarRgpd(event) {
            const ctx = getContext();
            ctx.rgpdAcceptat = event.target.checked;
            if (ctx.rgpdAcceptat) ctx.errorRgpd = '';
        },
        async subirFoto(event) {
            const ctx = getContext();
            const file = event.target.files?.[0];
            if (!file) return;

            ctx.fotoSubiendo = true;
            ctx.fotoError = '';
            ctx.fotoAttachmentId = 0;

            try {
                const config = getConfig();
                const formData = new FormData();
                formData.append('action', 'pp_subir_foto');
                formData.append('nonce', config.nonceFoto ?? '');
                formData.append('foto', file);

                const r = await fetch(config.ajaxUrl ?? '/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body: formData,
                });
                const data = await r.json();
                if (data.success) {
                    ctx.fotoAttachmentId = data.data?.attachmentId ?? 0;
                } else {
                    ctx.fotoError = data.data?.mensaje ?? 'Error en pujar la foto';
                }
            } catch (e) {
                ctx.fotoError = 'Error de xarxa en pujar la foto';
            } finally {
                ctx.fotoSubiendo = false;
            }
        },
    },
});
